import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import apiClient from '@/shared/services/apiClient';

export default function SubscribeForm() {
  const [email, setEmail] = useState('');

  const mutation = useMutation({
    mutationFn: async (emailAddr: string) => {
      const res = await apiClient.post('/newsletter/subscribe', { email: emailAddr });
      return res.data;
    },
    onSuccess: () => {
      toast.success('Check your email to confirm subscription.');
      setEmail('');
    },
    onError: () => {
      toast.error('Failed to subscribe. Try again later.');
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    mutation.mutate(email.trim());
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2 items-center">
      <input
        type="email"
        placeholder="your@email.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        className="px-2 py-1 border border-border rounded text-xs font-mono focus:outline-none focus:border-accent flex-1 min-w-0"
      />
      <button
        type="submit"
        disabled={mutation.isPending}
        className="btn-terminal text-xs whitespace-nowrap"
      >
        {mutation.isPending ? '...' : '[ SUBSCRIBE ]'}
      </button>
    </form>
  );
}
